import { makeStoreContext } from "src/mobx";

import { ProgramBuilderStore } from "./ProgramBuilderStore";

export const [
  ProgramBuilderContextProvider,
  useProgramBuilderContext,
  useProgramBuilderStore,
] = makeStoreContext(ProgramBuilderStore);

export function useOptionalProgramBuilderStore(): ProgramBuilderStore | null {
  const ctx = useProgramBuilderContext();
  return ctx?.store ?? null;
}
